module.exports = __webpack_public_path__ + "media/entities/5112-5a953701.png";